// headerハンバーガーメニュー
export function headerFunc() {
  $("#hamburger").click(function () {
    $(this).toggleClass('drawer-opened');
    $("#drawer").toggleClass('drawer-opened');
  });

  $("#drawer a").click(function () {
    $("#hamburger").removeClass('drawer-opened');
    $("#drawer").removeClass('drawer-opened');
  });
}
